// Default imports
import { createContext, useEffect, useContext, useState } from "react";
import { AuthContext } from "./AuthContext";
import { GET } from "../api/requests";
import { useQuery } from "react-query";

// Create context and client
export const TeamContext = createContext({
  session: null,
  setSession: () => {},
  teamId: null,
  teamInfo: {},
  roleOnCurrentTeam: null,
});

export const TeamProvider = ({ children }) => {
  // Import session and supabase from the Auth provider, needs to
  // be at a higher level in the hierarchy
  const { session, supabase } = useContext(AuthContext);
  const [team, setTeam] = useState(null);
  const [roleOnCurrentTeam, setRoleOnCurrentTeam] = useState(null);
  // Fetching teams data as before
  const {
    data: teams,
    isError,
    isLoading,
    error,
  } = useQuery(["teamInfo"], () => {
    return GET(`/organizations`, supabase);
  });

  useEffect(() => {
    // Try to get the stored team from localStorage when the component mounts
    const storedTeam = localStorage.getItem("team");
    if (storedTeam) {
      // If a team is stored, parse it and set it to the state
      setTeam(JSON.parse(storedTeam));
    } else if (teams && teams.length > 0) {
      // If there's no stored team but teams data is loaded, set the first team as default
      setTeam(teams[0]);
    }
    // This effect should run once on mount
  }, [teams]); // Depends on `teams` to ensure it runs again if `teams` is loaded after the component mounts

  // Persist the team state to localStorage and update the role on the current team whenever the `team` changes
  useEffect(() => {
    if (team) {
      localStorage.setItem("team", JSON.stringify(team));
      // Set the role if `relations` exist and there's at least one relation
      if (team.relations && team.relations[0]) {
        setRoleOnCurrentTeam(team.relations[0].relation);
      }
    }
  }, [team]); // This effect depends on `team`

  return (
    <TeamContext.Provider
      value={{
        team,
        teams,
        roleOnCurrentTeam,
        setTeam,
      }}
    >
      {children}
    </TeamContext.Provider>
  );
};
